.wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--tempest-space-1);
    width: 100%;
}

.label {
    font-size: var(--tempest-text-sm);
    font-weight: var(--tempest-weight-semibold);
    color: var(--tempest-text);
    line-height: var(--tempest-leading-snug);
}

.required {
    color: var(--tempest-danger);
    margin-left: 2px;
}

.field {
    position: relative;
    display: flex;
    align-items: center;
}

.input {
    width: 100%;
    height: var(--tempest-control-height-md);
    padding: 0 var(--tempest-control-padding-md);
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-control-radius);
    background-color: var(--tempest-bg);
    color: var(--tempest-text);
    font-family: var(--tempest-font-sans);
    font-size: var(--tempest-control-font-md);
    line-height: var(--tempest-leading-snug);
    box-shadow: var(--tempest-shadow-xs);
    transition: var(--tempest-transition-color), var(--tempest-transition-shadow);
}

.input::placeholder {
    color: var(--tempest-text-subtle);
}

.input:hover:not(:disabled):not(:focus) {
    border-color: var(--tempest-border-strong);
}

.input:focus {
    outline: none;
    border-color: var(--tempest-primary);
    box-shadow: 0 0 0 var(--tempest-focus-ring-width) var(--tempest-focus-ring-color);
}

.input:disabled {
    background-color: var(--tempest-surface);
    cursor: not-allowed;
    color: var(--tempest-text-muted);
    box-shadow: none;
}

.input:read-only {
    background-color: var(--tempest-surface);
}

/* Sizes — density-aware. Applied directly on the <input>. */
.sizeSm {
    height: var(--tempest-control-height-sm);
    padding: 0 var(--tempest-control-padding-sm);
    font-size: var(--tempest-control-font-sm);
}
.sizeMd {
    height: var(--tempest-control-height-md);
    padding: 0 var(--tempest-control-padding-md);
    font-size: var(--tempest-control-font-md);
}
.sizeLg {
    height: var(--tempest-control-height-lg);
    padding: 0 var(--tempest-control-padding-lg);
    font-size: var(--tempest-control-font-lg);
}

.hasLeftIcon {
    padding-left: 36px;
}

.hasRightIcon {
    padding-right: 36px;
}

.iconLeft,
.iconRight {
    position: absolute;
    display: flex;
    align-items: center;
    color: var(--tempest-text-muted);
    pointer-events: none;
}

/*
 * Decorative icons let clicks fall through to the input, but interactive
 * adornments (a clear/reveal/save button passed as leftIcon/rightIcon) must
 * stay clickable — re-enable pointer events on the slot's children.
 */
.iconLeft > *,
.iconRight > * {
    pointer-events: auto;
}

.iconLeft {
    left: 12px;
}

.iconRight {
    right: 12px;
}

.error .input {
    border-color: var(--tempest-danger);
}

.error .input:focus {
    box-shadow: 0 0 0 var(--tempest-focus-ring-width)
        color-mix(in srgb, var(--tempest-danger) 25%, transparent);
}

.helper {
    font-size: var(--tempest-text-xs);
    color: var(--tempest-text-muted);
    line-height: var(--tempest-leading-snug);
}

.errorText {
    font-size: var(--tempest-text-xs);
    color: var(--tempest-danger);
    line-height: var(--tempest-leading-snug);
}
